export default __webpack_public_path__ + "static/media/carpet.db2b957b.jpg";